import home from "../../images/home.jpg";
import home2 from "../../images/home2.jpg";
import home3 from "../../images/home3.png";
import { Link, NavLink } from "react-router-dom";
// import { product } from "../ProductList/ProductList";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import "./app.css";
// import { AiFillRightCircle, AiFillLeftCircle } from "react-icons/ai";
import Navigation from "../navigation/Navigation";
import { useState } from "react";
import { BiCartAlt, BiMoon, BiSun, BiUser } from "react-icons/bi";
import { MdLanguage } from "react-icons/md";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import i18next from "i18next";
import { useEffect } from "react";
const categoryName = ["kids", "comedy", "love", "cooking", "classic"];

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="slick-arrow absolute z-10  top-[70px] y9:top-[85px] md:top-[90px] lg:top-[105px] right-[-20px] lg:right-[-3px] "
      onClick={onClick}
    >
      <div
        className="flex justify-center  rounded-[50%] bg-black bg-opacity-50 w-[35px] h-[35px] md:w-[50px] md:h-[50px]  cursor-pointer text-[16px] md:text-[19px] 
   hover:text-[18px] hover:w-[37px] hover:h-[37px]  hover:md:text-[21px] hover:md:w-[52px] hover:md:h-[52px] hover:bg-opacity-60 duration-100  "
      >
        <FaChevronRight className="text-white  self-center  " />
      </div>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="slick-arrow absolute z-10 top-[70px] y9:top-[85px] md:top-[90px] lg:top-[105px] left-[-20px] lg:left-[-30px] "
      onClick={onClick}
    >
      <div
        className="flex justify-center  rounded-[50%] bg-black bg-opacity-50 w-[35px] h-[35px] md:w-[50px] md:h-[50px]  cursor-pointer text-[16px] md:text-[19px] 
      hover:text-[18px] hover:w-[37px] hover:h-[37px]  hover:md:text-[21px] hover:md:w-[52px] hover:md:h-[52px] hover:bg-opacity-60 duration-100 
"
      >
        <FaChevronLeft className="text-white  self-center  " />
      </div>
    </div>
  );
}

const Body = ({ products, setTheme, theme, changeLanguage }) => {
  const [menu, setMenu] = useState(false);
  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 5,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          // slidesToScroll: 4,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // initialSlide: 3,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // initialSlide: 3,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          // slidesToScroll: 3,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 2,
          // slidesToScroll: 3,
          infinite: true,
          // dots: true
        },
      },
    ],
  };
  const [IsLogin, setIsLogin] = useState([]);
  const IsSingup = localStorage.getItem("user");
  useEffect(() => {
    setIsLogin(localStorage.getItem("user"));
  }, []);

  useEffect(() => {
    if (IsSingup) {
      setIsLogin(IsSingup);
    } else {
      setIsLogin([]);
    }
  }, [IsSingup]);
  return (
    <div className="">
      <div className=" z-30 sticky top-0  ">
        <Navigation
          setTheme={setTheme}
          theme={theme}
          menu={menu}
          setMenu={setMenu}
          changeLanguage={changeLanguage}
        />
      </div>

      <div className="">
        <div className="flex justify-center">
          <div className="flex flex-col self-center  w-full  ">
            <div className="flex justify-center">
              <div className="mt-4 mb-2 ml-2 hidden y9:flex">
                <ul className="flex mb-4 dark:text-white font-semibold text-Darktext">
                  {categoryName.map((category) => (
                    <NavLink to={`/${category}`}>
                      <li
                        key={category}
                        className="border border-[#717374] px-4 
                     rounded-md mr-2  hover:bg-btnMain hover:text-white transition ease-in-out delay-75  hover:border-btnMain hover:-translate-y-[1px] duration-200"
                      >
                        <button>{category} </button>
                      </li>
                    </NavLink>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col mx-5">
          <div className="flex flex-col  self-center ">
              <div>
                <Link to={"/kids"}>
                  <img src={home2} alt="" className="  md:m-1 mt-1 " />
                </Link>
              </div>
          

          </div>

          <div className="flex flex-col self-center   mt-10  ">
            <div className="flex dark:bg-Darksecondcolor bg-white self-center "></div>
          </div>

          {/* <div className="flex flex-col self-center   mt-10 ">
            <div className="flex flex-col  dark:bg-Darksecondcolor bg-white self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px]">Kids</p>
                <Link to={"/kids"}>
                  <p className=" text-[#417ed4] p-2 ">view all</p>
                </Link>
              </div>

              <div className="flex">
                {/* <button className="overflow-clip">
                  <AiFillLeftCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button> */}

          {/* <div 
                id="g"
                  className="flex overflow-x-scroll scroll scroll-smooth max-w-[1170px] w-[70vw] self-center
                  scrollbar dark:scrollbar-track-[#282a2c] scrollbar-track-secondtext dark:scrollbar-thumb-[#64778a] scrollbar-thumb-Darksecondtext scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm
          mt-2 duration-500
            "
                >
                  {products.map((p) => (
                    <div className="c min-w-[116px] h-[167] md:min-w-[185px] md:h-[280px] flex flex-row justify-center mb-4 ">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4 "
                      >
                        <img
                          src={p.image}
                          alt=""
                          className=" w-[165px] self-center  rounded-sm
                          hover:scale-105 hover:rounded-md ease-in-out  duration-300
         
                          "
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                 <button className="overflow-clip text-black duration-500"
                 
                 onClick={(e)=>{e.preventDefault();
                let con = document.getElementById("g");
                con.scrollLeft = con.scrollLeft+ 500
                
                }}
                 >
              mddd
                </button> 
              </div>
            </div>
          </div>  */}

          {/* <MultipleItems/> */}

          {categoryName.map((category) => (
            <div
              className="flex justify-center  dark:bg-Darksecondcolor bg-white self-center rounded-sm
p-3 px-5 md:px-8 "
            >
              <div className="max-w-[1170px] w-[75vw]   ">
                <div className="flex justify-between pb-5 text-[15px]  font-semibold text-btnMain ">
                  <h2 className="text-[22px] font-bold ">{category} </h2>
                  <Link to={`/${category}`}>
                    <h3>view All</h3>
                  </Link>
                </div>
                <Slider {...settings}>
                  {products.map((p) =>
                    p.category === category ? (
                      <div className="self-center">
                        <Link
                          to={`/${p.category}/${p.id}`}
                          className="self-center mb-4 "
                        >
                          <img
                            src={p.image}
                            alt=""
                            className="  px-1 w-[180px] min-w-[130px] self-center  rounded-sm
                          hover:scale-105 hover:rounded-md ease-in-out  duration-300
         
                          "
                          />
                        </Link>
                      </div>
                    ) : null
                  )}
                </Slider>
              </div>
            </div>
          ))}

          {/* <div className="flex flex-col self-center   mt-10 ">
            <div className="flex flex-col  bg-[#1a1c1e] self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px]">Love</p>
                <Link to={"/love"}>
                  <p className=" text-[#417ed4] p-2 ">view all</p>
                </Link>
              </div>

              <div className="flex">
                <button className="overflow-clip">
                  <AiFillLeftCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>

                <div
                  className="flex overflow-x-scroll max-w-[1170px] w-[70vw] self-center
           scrollbar scrollbar-track-[#282a2c] scrollbar-thumb-[#64778a] scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm
          mt-2
            "
                >
                  {products.map((p) => (
                    <div className="min-w-[185px] h-[280px] flex flex-row justify-center mb-4 ">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4"
                      >
                        <img
                          src={p.image}
                          alt=""
                          className=" w-[165px] self-center hover:z-10 hover:w-[170px] rounded-sm
                          hover:-transition  duration-200"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                <button className="overflow-clip">
                  <AiFillRightCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col self-center   mt-10 ">
            <div className="flex flex-col  bg-[#1a1c1e] self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px]">Comdey</p>
                <Link to={"/comedy"}>
                  <p className=" text-[#417ed4] p-2 ">view all</p>
                </Link>
              </div>

              <div className="flex">
                <button className="overflow-clip">
                  <AiFillLeftCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>

                <div
                  className="flex overflow-x-scroll max-w-[1170px] w-[70vw] self-center
           scrollbar scrollbar-track-[#282a2c] scrollbar-thumb-[#64778a] scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm
          mt-2
            "
                >
                  {products.map((p) => (
                    <div className="min-w-[185px] h-[280px] flex flex-row justify-center mb-4 ">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4"
                      >
                        <img
                          src={p.image}
                          alt=""
                          className=" w-[165px] self-center hover:z-10 hover:w-[170px] rounded-sm
                          hover:-transition  duration-200"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                <button className="overflow-clip">
                  <AiFillRightCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col self-center   mt-10 ">
            <div className="flex flex-col  bg-[#1a1c1e] self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px]">Classic</p>
                <Link to={"/classic"}>
                  <p className=" text-[#417ed4] p-2 ">view all</p>
                </Link>
              </div>

              <div className="flex">
                <button className="overflow-clip">
                  <AiFillLeftCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>

                <div
                  className="flex overflow-x-scroll max-w-[1170px] w-[70vw] self-center
           scrollbar scrollbar-track-[#282a2c] scrollbar-thumb-[#64778a] scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm
          mt-2
            "
                >
                  {products.map((p) => (
                    <div className="min-w-[185px] h-[280px] flex flex-row justify-center mb-4 ">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4"
                      >
                        <img
                          src={p.image}
                          alt=""
                          className=" w-[165px] self-center hover:z-10 hover:w-[170px] rounded-sm
                          hover:-transition  duration-200"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                <button className="overflow-clip">
                  <AiFillRightCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col self-center   mt-10 ">
            <div className="flex flex-col  bg-[#1a1c1e] self-center rounded-sm">
              <div className="flex justify-between">
                <p className="mt-2 ml-4 text-[20px]">Cooking</p>
                <Link to={"/cooking"}>
                  <p className=" text-[#417ed4] p-2 ">view all</p>
                </Link>
              </div>

              <div className="flex">
                <button className="overflow-clip">
                  <AiFillLeftCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>

                <div
                  className="flex overflow-x-scroll max-w-[1170px] w-[70vw] self-center
           scrollbar scrollbar-track-[#282a2c] scrollbar-thumb-[#64778a] scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm
          mt-2
            "
                >
                  {products.map((p) => (
                    <div className="min-w-[185px] h-[280px] flex flex-row justify-center mb-4 ">
                      <Link
                        to={`/${p.category}/${p.id}`}
                        className="self-center mb-4"
                      >
                        <img
                          src={p.image}
                          alt=""
                          className=" w-[165px] self-center hover:z-10 hover:w-[170px] rounded-sm
                          hover:-transition  duration-200"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
                <button className="overflow-clip">
                  <AiFillRightCircle
                    className="text-[25px]
             text-[#417ed4]"
                  />
                </button>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          setMenu(false);
        }}
        className={` ${!menu && "scale-x-0"} ${
          i18next.language === "en" ? "origin-right " : "origin-left"
        } duration-300 absolute w-[100%] h-[1400px] z-30  top-0 dark:bg-opacity-60 dark:bg-black backdrop-blur-md bg-lightscreen bg-opacity-40 `}
      ></div>
      <div />

      <div
        className={`absolute top-16 z-40  ${
          i18next.language === "en" ? "right-0" : "left-0"
        } top-10 ${!menu && "scale-x-0"} ${
          i18next.language === "en"
            ? "origin-right border-l  w-48 pb-8"
            : "origin-left border-r w-48 pb-8"
        }  border-border 
              duration-300 flex flex-col justify-center text-[17px] pt-5 dark:text-white text-black  font-semibold  `}
      >
        {IsLogin.length === 0 ? (
          <div className="self-center ">
            <Link
              to={"/login"}
              className="bg-btnMain text-white px-12  text-[17px] rounded-sm hover:rounded-md hover:px-14 duration-300 py-2 my-2"
            >
              Login
            </Link>
          </div>
        ) : (
          <div className="py-6 flex mx-2 border-b cursor-pointer  border-border w-28 hover:text-[18px] duration-200 ">
            <div className="self-center mx-2 text-[21px]">
              <BiUser />{" "}
            </div>
            <div>User</div>
          </div>
        )}

        <div className="py-6 flex mx-2 cursor-pointer  border-b border-border w-28 hover:text-[18px] duration-200">
          <div className="self-center mx-2 text-[21px]">
            <BiCartAlt />
          </div>
          <Link to={"/cart"}>Cart</Link>
        </div>
        <div className="py-6 flex mx-2  border-b border-border w-28 hover:text-[18px] duration-200">
          <div className="self-center cursor-pointer mx-2 text-[22px]">
            {theme === "lightTheme" ? (
              <BiMoon
                onClick={() => {
                  setTheme("darkTheme");
                }}
              />
            ) : (
              <BiSun
                onClick={() => {
                  setTheme("lightTheme");
                }}
              />
            )}
          </div>
          <div>Theme</div>
        </div>
        <div
          onClick={() => changeLanguage()}
          className="py-6 flex mx-2 cursor-pointer y9:border-0 border-b border-border hover:text-[18px] duration-200"
        >
          <div className="self-center mx-2 text-[21px] ">
            <MdLanguage />
          </div>
          <div>{i18next.language === "en" ? "فا" : "En"}</div>
        </div>
        <div className="mx-2 flex flex-col y9:hidden">
          {categoryName.map((category) => (
            <Link to={`/${category}`}>
              <div className="py-6 text-[18px] mx-2 border-b border-border w-28 hover:text-[18px] duration-200 ">
                {category}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Body;
